import { collection, getDocs, query, where, type Firestore } from 'firebase/firestore';
import type { AppUser } from '@kawai/shared';
import { db as defaultDb } from '../firebase.js';

/**
 * N-15b: 自テナントの全顧客プロフィールを取得する（通知先の LINE 宛先ピッカー用）。
 * tenant-promo / tenant-reservation の `fetchAllUsers` をこのリポジトリの流儀どおり
 * コピーした（packages 化はしない）。
 *
 * - Rules `users/{uid}` は admin に対し `belongsToMyTenant()` で read 許可（rules 変更不要）
 * - `uid` が欠落した古い doc は document id にフォールバックする
 */
export async function fetchAllUsers(
  tenantId: string,
  db: Firestore = defaultDb,
): Promise<AppUser[]> {
  const snap = await getDocs(
    query(collection(db, 'users'), where('tenantId', '==', tenantId)),
  );
  return snap.docs.map((d) => {
    const data = d.data() as Partial<AppUser>;
    return { ...data, uid: data.uid ?? d.id } as AppUser;
  });
}
